<script lang="ts" setup>
// Core
import { onBeforeMount } from "vue";

// Components
import Icon from "@/components/core/IconCore.vue";

// Assets
import logoIcon from "@/assets/logos/logo.svg?url";

onBeforeMount(() => {
  if (localStorage.getItem("theme")) {
    localStorage.removeItem("theme");
  }

  document.body.setAttribute("data-theme", "light");
});
</script>

<template>
  <div class="auth-page">
    <Icon :icon-src="logoIcon" :icon-size="'190px'" auto-heigth />
    <router-view />
  </div>
</template>

<style lang="scss" scoped>
.auth-page {
  @include flex-center(column);
  background-image: url(/src/assets/img/onboarding/background-mobile.svg);
  background-color: #ffffff;
  min-height: 100vh;
  gap: $spacing_md_lg;
}

:deep(.card-auth) {
  width: 100%;
  max-width: 475px;
  padding: $spacing_md_plus_xl;
  border: 0;

  a {
    color: $new-primary_7;
    text-decoration: underline;
  }

  .card-auth__content {
    @include flex-center(column);
    max-width: 390px;
    margin-inline: auto;
    margin-bottom: $spacing_md_lg;
    gap: $spacing_sm;

    > div {
      @include flex-center(column);
      text-align: center;

      span {
        font-weight: $fw_md;
        line-height: $lh_mdx;
        color: $new-neutral_12;
      }

      p {
        font-weight: $fw_md;
        line-height: $lh_md;
        color: $new-neutral_11;
      }
    }

    .subscription {
      span {
        font-size: $fs_sm;
      }

      p {
        font-size: $fs_ssm;
      }
    }
  }

  .card-auth__form {
    @include flex(column, stretch);
    gap: $spacing_md;

    .input {
      box-shadow: $input_box_shadow;
    }
  }

  .card-auth__footer {
    @include flex(row, center, space-between);
    gap: $spacing_sm;

    .remember-password {
      @include flex(row, center);
      gap: $spacing_sm;
      cursor: pointer;
    }

    a {
      font-size: $fs_ssm;
    }

    .main-button {
      min-width: 84px;
    }

    &.center a {
      @include flex-center;
      width: 100%;
      margin-top: $spacing_sm;
      font-size: $fs_sm;
      text-align: center;
    }
  }

  @media (max-width: $tablet_sm) {
    padding: $spacing_md_plus_minus_xl;
  }
}
</style>
